invHdApp.controller('RouteController', ['$scope', 'Route', 'Order', '$location', '$filter', '$interval',
	'ngAudio', '$routeParams', '$rootScope', '$window', '$http', '$timeout', '$http', 'RouteList', '$translate',
	function ($scope, Route, Order, $location, $filter, ngAudio, $routeParams, $rootScope, $window, $http, $interval, $timeout, $http, RouteList, $translate) {

		$scope.directionsService = [];
		$scope.directionsDisplay = [];
		$scope.selectedMarkers = [];
		$scope.selectedForEditOrder = [];
		$scope.editMode = false;
		var bounds = new google.maps.LatLngBounds();
		var colorArray = ['#FF6633', '#FF33FF', '#FFFF99', '#00B3E6',
			'#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
			'#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
			'#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
			'#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
			'#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
			'#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
			'#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
			'#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
			'#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF', '#FFB399'
		];

		$scope.filterPanel = false;
		$scope.data = {};
		$scope.worker_id = 0;
		$scope.selectedTab = 'routes';
		$scope.filterData = {
			workers: [],
			workSteps: [],
			created_at: {
				startDate: null,
				endDate: null
			},
			scheduled_time: {
				startDate: null,
				endDate: null
			}
		}

		$scope.getWorkerOrders = function (item) {
			return item.worker_id === $scope.sWorker.id;
		}

		$scope.searchOrder = function (term) {
			$scope.filterData.term = term;
			$scope.init();
		}

		$scope.initMap = function () {
			$scope.map = new ymaps.Map('route-map', {
				center: [41.015137, 28.979530], // İstanbul merkezi
				zoom: 10,
				controls: ['zoomControl', 'fullscreenControl']
			});
			const mapContainer = document.getElementById('route-map');
			mapContainer.style.zoom = 1.15;
		}

		$scope.init = function (type) {
			if (type === 'clear') {
				$scope.filterData = {
					term: '',
					workers: [],
					workSteps: [],
					created_at: { startDate: null, endDate: null },
					scheduled_time: { startDate: null, endDate: null }
				};
			}

			Route.routeOrders($scope.filterData).success(function (data, status, headers, config) {
				$scope.data.orders = data.orders;
				$scope.markers = {
					'order': []
				};
				$scope.infowindows = [];
				$scope.infowindowsOrder = [];

				// Haritayı başlat
				ymaps.ready(() => {
					if (!$scope.map) {
						$scope.map = new ymaps.Map('route-map', {
							center: [41.015137, 28.979530],
							zoom: 10,
							controls: ['zoomControl', 'fullscreenControl']
						});
						const mapContainer = document.getElementById('route-map');
						mapContainer.style.zoom = 1.15;
					} else {
						$scope.map.geoObjects.removeAll();
					}

					$scope.orderMarkers = [];

					// Order'ları işle
					data.orders.forEach(order => {
						if (order.location && order.location.latitude && order.location.latitude.trim() && order.location.latitude !== ' ') {
							$scope.createOrderMarker(order, '#828c95');
						}
					});

					// Route'ları yükle ve işle
					$scope.initRoute(type);
				});
			});
		};

		$scope.initRoute = function (type) {
			Route.initRoute($scope.filterData).success(function (data, status, headers, config) {
				$scope.data.routes = data.routes;

				// Önceki route'ları temizle
				$scope.data.routes.forEach(element => {
					if ($scope.directionsDisplay[element.id]) {
						$scope.map.geoObjects.remove($scope.directionsDisplay[element.id]);
						$scope.directionsDisplay[element.id] = null;
					}
				});

				// Route'ları çiz
				setTimeout(() => {
					$scope.data.routes.forEach((element, index) => {
						element.color = colorArray[index];
						renderRoute(element, element.color, type);

						// Route'a ait order'ların rengini güncelle
						if (element.orders) {
							element.orders.forEach(order => {
								if ($scope.orderMarkers[order.id]) {
									$scope.orderMarkers[order.id].options.set('iconColor', element.color);
								}
							});
						}
					});

					// Haritayı tüm noktaları gösterecek şekilde ayarla
					fitMapToBounds();
				}, 100);
			});
		};

		function fitMapToBounds() {
			let bounds = [];

			// Tüm noktaları topla
			if ($scope.data.orders) {
				$scope.data.orders.forEach(order => {
					if (order.location && order.location.latitude && order.location.longitude) {
						bounds.push([
							Number(order.location.latitude),
							Number(order.location.longitude)
						]);
					}
				});
			}

			if (bounds.length > 0) {
				const latMin = Math.min(...bounds.map(p => p[0]));
				const latMax = Math.max(...bounds.map(p => p[0]));
				const lngMin = Math.min(...bounds.map(p => p[1]));
				const lngMax = Math.max(...bounds.map(p => p[1]));

				// Margin ekle
				const margin = 0.1;
				const latDiff = (latMax - latMin) * margin;
				const lngDiff = (lngMax - lngMin) * margin;

				$scope.map.setBounds([
					[latMin - latDiff, lngMin - lngDiff],
					[latMax + latDiff, lngMax + lngDiff]
				], {
					checkZoomRange: true,
					duration: 500,
					timingFunction: 'ease-in-out'
				});
			}
		}

		$scope.createOrderMarker = function (order, defaultColor) {
			if (order.location && order.location.latitude && order.location.longitude) {
				// Order'ın route'unu ve rengini bul
				let color = defaultColor;
				if ($scope.data.routes) {
					for (let route of $scope.data.routes) {
						if (route.orders && route.orders.some(o => o.id === order.id)) {
							color = route.color;
							break;
						}
					}
				}

				// Balloon içeriği
				var content = '<div id="iw-container">' +
					'<div class="iw-content"> ' +
					'<strong>#' + order.id + '</strong>';
				if (order.special_value) {
					content += ' - <strong>' + order.special_value + '</strong>';
				}
				content += '<hr style="margin:17px 0">' +
					'<p>' + order.customer.customer_name + ' </p>' +
					'<p>' + order.location.name + '</p>' +
					'<p>' + order.location.address + '</p>' +
					'<div class="row"><div class="col-md-6 pull-left">' +
					'<a href="javascript:void(0)" onclick="angular.element(this).scope().zoomIn(' + order.location.latitude + ',' + order.location.longitude + ')" class="gk-button blue btn-xs"><i class="fa fa-search-plus"></i></a> </div>' +
					'<div class="col-md-6 pull-left"><a href="javascript:void(0)" onclick="angular.element(this).scope().getOrderDetails(' + order.id + ')" class="gk-button blue btn-xs pull-right"><i class="fa fa-eye"></i></a> </div></div>';
				if (order.worker) {
					content += '<p>' + order.worker.full_name + '</p>';
				}
				content += '</div></div>';

				// Marker oluşturma
				var marker = new ymaps.Placemark([
					Number(order.location.latitude),
					Number(order.location.longitude)
				], {
					hintContent: '#' + order.id,
					// balloonContent: createBalloonContent(order),
					balloonContentBody: content
					// iconContent: order.id.toString()
				}, {
					preset: 'islands#circleIcon',
					iconColor: color,
				});

				$scope.map.geoObjects.add(marker);
				$scope.orderMarkers[order.id] = marker;
			}
		};

		$scope.assignToRoute = function (id) {
			var order = find($scope.data.orders, id);
			$scope.selectedForEditOrder.push(order);
		}

		function find(data, find) {
			var index = data.indexOf($filter('filter')(data, {
				id: find
			})[0]);
			if (index > -1)
				return data[index];
		}

		$scope.zoomIn = function (lat, lng) {
			$scope.map.setCenter([Number(lat), Number(lng)]);
			$scope.map.setZoom(16);
		}

		function updateRouteInfo(routeId, distance, duration) {
			var index = $scope.data.routes.findIndex(r => r.id === routeId);
			if (index > -1) {
				$scope.data.routes[index].total_mile = distance / 1609;
				$scope.data.routes[index].total_time = duration * 1000;

				RouteList.updateField({
					id: routeId,
					total_time: duration * 1000,
					distance: distance
				});
			}
		}

		$scope.editRoute = function () {
			$scope.editMode = true;

			// Polygon options
			var polygonOptions = {
				fillColor: '#00FF0088', // son iki karakter alpha değeri
				strokeColor: '#0000FF',
				strokeWidth: 2,
				editorMaxPoints: 100,
				editorMenuManager: true
			};

			// Polygon oluştur
			var polygon = new ymaps.Polygon([], {}, polygonOptions);

			// Haritaya ekle
			$scope.map.geoObjects.add(polygon);

			// Çizim modunu başlat
			polygon.editor.startDrawing();

			// Polygon tamamlandığında
			polygon.events.add(['geometrychange', 'editorstatechange'], function (e) {
				try {
					var coordinates = polygon.geometry.getCoordinates();
					// Polygon en az 3 nokta içeriyorsa işlem yap
					if (coordinates && coordinates[0] && coordinates[0].length > 2) {
						findOrdersInPolygon(coordinates[0], polygon);
					}
				} catch (error) {
					console.error('Polygon event error:', error);
				}
			});
		}

		function findOrdersInPolygon(polygonCoords, polygon) {
			$scope.selectedForEditOrder = []; // Reset selected orders

			// Routes içindeki siparişleri kontrol et
			if ($scope.data.routes) {
				$scope.data.routes.forEach(route => {
					if (route.orders) {
						route.orders.forEach(order => {
							checkOrderInPolygon(order, polygonCoords);
						});
					}
				});
			}

			// Diğer siparişleri kontrol et
			if ($scope.data.orders) {
				$scope.data.orders.forEach(order => {
					checkOrderInPolygon(order, polygonCoords);
				});
			}

			// Angular'ın değişiklikleri algılaması için
			if (!$scope.$$phase) {
				$scope.$apply();
			}
		}

		function checkOrderInPolygon(order, polygonCoords) {
			if (order.location && order.location.latitude && order.location.longitude) {
				var point = [
					Number(order.location.latitude),
					Number(order.location.longitude)
				];

				// Noktanın polygon içinde olup olmadığını kontrol et
				if (isPointInPolygon(point, polygonCoords)) {
					if (!$scope.selectedForEditOrder.some(selected => selected.id === order.id)) {
						$scope.selectedForEditOrder.push(order);
					}
				}
			}
		}

		function isPointInPolygon(point, polygon) {
			// Ray casting algorithm
			var x = point[0], y = point[1];
			var inside = false;

			for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
				var xi = polygon[i][0], yi = polygon[i][1];
				var xj = polygon[j][0], yj = polygon[j][1];

				var intersect = ((yi > y) !== (yj > y))
					&& (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
				if (intersect) inside = !inside;
			}

			return inside;
		}

		$scope.closeEditRoute = function () {
			$scope.editMode = false;
			$scope.selectedForEditOrder = [];

			// Haritadaki tüm polygon'ları temizle
			$scope.map.geoObjects.each(function (geoObject) {
				if (geoObject instanceof ymaps.Polygon) {
					$scope.map.geoObjects.remove(geoObject);
				}
			});
		}

		$scope.initData = function () {
			Route.initData().success(function (data, status, headers, config) {
				$scope.data.workers = data.workers;
				$scope.data.steps = data.steps;
				$scope.data.types = data.types;
				$scope.data.fields = data.fields;
				$scope.data.customers = data.customers;
				$scope.data.stations = data.stations;
				$scope.data.steps.unshift({
					id: 0,
					name: 'Oluşturuldu'
				});
				$scope.filterData.station_id = data.stations[0].id;
			});
		}
		$scope.initData();

		$scope.assignToWorker = function (worker_id) {
			$scope.optimizationSpinner = true;
			Route.assignToWorker({
				worker_id: worker_id,
				route_id: $scope.selectedRoute.id
			}).success(function (data, status, headers, config) {
				$scope.initRoute();
				$scope.optimizationSpinner = false;
				Messenger().post('Successfull');
				$('#assignToWorkerRoute').modal('hide');
			}).error(function (data) {
				alert('Error');
			});
		}

		$scope.openOptimize = function () {
			// if ($scope.selectedForEditOrder.length == 0) {
			// 	alert($translate.instant('PLEASE_SELECT_ORDER'));
			// 	return true;
			// }
			RouteList.new().success(function (data, status, headers, config) {
				$scope.rtstations = data.stations;
				$scope.newRouteData = {
					scheduled_start: '4:30',
					scheduled_end: '8:30',
				}
				$rootScope.newRouteData = {
					scheduled_start: '4:30',
					scheduled_end: '8:30',
				}
				jQuery('#startrt').datetimepicker({
					format: 'H:i',
					formatTime: 'H:i',
					datepicker: false,
					step: 30,
				});
				jQuery('#endrt').datetimepicker({
					format: 'H:i',
					formatTime: 'H:i',
					datepicker: false,
					step: 30,
				})
				$('#optimizeRoute').modal('show');
			});
		}

		$scope.createRoute = function () {
			$scope.optimizationSpinner = true;
			var orders = [];
			$scope.selectedForEditOrder.forEach(element => {
				orders.push(element.id);
			});
			$scope.newRouteData.orders = orders
			$scope.newRouteData.count = 1;
			$scope.newRouteData.deviation = 0;
			RouteList.save($scope.newRouteData).success(function (data, status, headers, config) {
				Messenger().post(data.message);
				$('#optimizeRoute').modal('hide');
				$scope.initRoute();
				$scope.$broadcast('refresh_data');
				$scope.newRouteData = {
					scheduled_start: '4:30',
					scheduled_end: '8:30',
				}
				$rootScope.newRouteData = {
					scheduled_start: '4:30',
					scheduled_end: '8:30',
				}
			}).error(function (data) {
				Messenger().post({
					message: data.message,
					type: "error"
				});
			});
		}

		$scope.selectedOrders = [];
		$scope.openRoute = function (data) {
			if (!data.orders || data.orders.length === 0) return;

			try {
				// Önceki route'ları temizle
				$scope.map.geoObjects.each(function (geoObject) {
					// if (geoObject instanceof ymaps.Route) {
					// 	$scope.map.geoObjects.remove(geoObject);
					// }
				});

				// Waypoints oluştur
				var waypoints = data.orders.map(element => {
					if (element.location && element.location.latitude && element.location.longitude) {
						return [Number(element.location.latitude), Number(element.location.longitude)];
					}
				}).filter(point => point !== undefined);

				if (waypoints.length > 1) {
					// Route oluştur

					var bounds = [];
					waypoints.forEach(point => {
						bounds.push(point);
					});

					if (bounds.length > 0) {
						// Min-max koordinatları bul
						var latMin = Math.min(...bounds.map(p => p[0]));
						var latMax = Math.max(...bounds.map(p => p[0]));
						var lngMin = Math.min(...bounds.map(p => p[1]));
						var lngMax = Math.max(...bounds.map(p => p[1]));

						// Margin ekle
						var margin = 0.1;
						var latDiff = (latMax - latMin) * margin;
						var lngDiff = (lngMax - lngMin) * margin;

						// Haritayı bounds'a göre ayarla
						$scope.map.setBounds([
							[latMin - latDiff, lngMin - lngDiff],
							[latMax + latDiff, lngMax + lngDiff]
						], {
							checkZoomRange: true,
							duration: 500,
							timingFunction: 'ease-in-out'
						});

						// Route bilgilerini al
						//var activeRoute = data.getPaths().get(0);
						//var routeInfo = {
						//	distance: activeRoute.getLength(),
						//	duration: activeRoute.getTime()
						//};

						//// Scope'u güncelle
						//$scope.$apply(function () {
						//	$scope.currentRouteInfo = {
						//		distance: (routeInfo.distance / 1000).toFixed(2) + ' km',
						//		duration: Math.round(routeInfo.duration / 60) + ' min'
						//	};
						//});
					}

				}
			} catch (error) {
				console.error('Error in openRoute:', error);
				Messenger().post({
					message: 'Bir hata oluştu',
					type: 'error'
				});
			}
		};

		function createBalloonContent(order) {
			var content = '<div class="balloon-content">';
			content += '<h3>#' + order.id + '</h3>';
			if (order.name) {
				content += '<p>' + order.name + '</p>';
			}
			if (order.customer) {
				content += '<p><strong>Müşteri:</strong> ' + order.customer.customer_name + '</p>';
			}
			if (order.location) {
				content += '<p><strong>Adres:</strong> ' + order.location.address + '</p>';
			}
			if (order.special_value) {
				content += '<p><strong>Özel Değer:</strong> ' + order.special_value + '</p>';
			}
			content += '</div>';
			return content;
		}

		$scope.delete = function (route) {
			var r = confirm($translate.instant("ARE_U_SURE_DELETE"));
			if (r == true) {
				Route.delete(route.id).success(function (data, status, headers, config) {
					$scope.data.routes.forEach((element, index) => {
						if (element.id == route.id) {
							$scope.data.routes.splice(index, 1);
						}
					});
					Messenger().post('Successfull');
				}).error(function (data) {
					Messenger().post({
						message: data.message,
						type: "error"
					});
				});
			}
		};

		function clearRoute(id) {
			if ($scope.directionsDisplay[id] != null) {
				$scope.directionsDisplay[id].setMap(null);
				$scope.directionsDisplay[id] = null;
			}
		}

		$scope.assignOrderToRoute = function (route_id) {
			var orders = [];
			$scope.selectedForEditOrder.forEach(element => {
				orders.push(element.id)
			});
			var data = {
				route_id: route_id,
				orders: orders
			};
			$scope.optimizationSpinner = true;

			Order.assignOrderToRoute(data).success(function (data, status, headers, config) {
				// Poligonu temizle
				$scope.map.geoObjects.each(function (geoObject) {
					if (geoObject instanceof ymaps.Polygon) {
						$scope.map.geoObjects.remove(geoObject);
					}
				});

				// Seçili siparişleri temizle
				$scope.selectedForEditOrder = [];

				// Edit modunu kapat
				$scope.editMode = false;

				// Tüm datayı yeniden yükle
				Route.routeOrders($scope.filterData).success(function (data) {
					$scope.data.orders = data.orders;

					// Haritadaki tüm elementleri temizle
					$scope.map.geoObjects.removeAll();

					// Marker'ları yeniden oluştur
					var bounds = [];
					$scope.data.orders.forEach(order => {
						if (order.location && order.location.latitude && order.location.longitude) {
							var point = [Number(order.location.latitude), Number(order.location.longitude)];
							bounds.push(point);
							$scope.createOrderMarker(order, '#828c95');
						}
					});

					// Route'ları yeniden çiz
					Route.initRoute($scope.filterData).success(function (routeData) {
						$scope.data.routes = routeData.routes;

						setTimeout(() => {
							$scope.data.routes.forEach((element, index) => {
								renderRoute(element, colorArray[index], type);
								element.color = colorArray[index];
							});
						}, 100);
					});
				});

				$scope.optimizationSpinner = false;
			}).error(function (data) {
				alert(data);
				$('#orderInfo').modal('show');
				$scope.optimizationSpinner = false;
			});
		};

		$scope.totalDistance = [];
		$scope.totalDuration = [];
		function renderRoute(data, color) {
			if (!data.orders || data.orders.length === 0) return;

			const points = data.orders
				.filter(order => order.location && order.location.latitude)
				.map(order => [
					Number(order.location.latitude),
					Number(order.location.longitude)
				]);

			if (points.length < 2) return;

			ymaps.route(points, {
				mapStateAutoApply: false,
				routingMode: 'auto'
			}).then(route => {
				route.getPaths().options.set({
					strokeColor: color,
					strokeWidth: 5,
					opacity: 0.8
				});

				$scope.map.geoObjects.add(route);

				// Route bilgilerini güncelle
				const distance = route.getLength();
				const duration = route.getTime();

				$scope.$apply(() => {
					updateRouteInfo(data.id, distance, duration);
				});
			}).catch(error => {
				console.error('Route rendering error:', error);
			});
		}

		$scope.$on('refresh_data', function () {
			console.log('refreshing map...')
			$scope.init();
			$scope.selectedOrders = [];
		}, true);

		$scope.clearFilter = function (page) {
			$scope.filterData = {
				workers: [],
				workSteps: [],
				created_at: {
					startDate: null,
					endDate: null
				},
				scheduled_time: {
					startDate: null,
					endDate: null
				}
			}
			$scope.filterProp = [];
			$scope.refreshData('map');
		}

		function getOrderColor(order, routes) {
			// Eğer order bir route'a aitse o route'un rengini kullan
			for (let i = 0; i < routes.length; i++) {
				if (routes[i].orders.some(o => o.id === order.id)) {
					return routes[i].color || colorArray[i];
				}
			}
			// Route'a ait değilse varsayılan gri renk
			return '#828c95';
		}

		$scope.calculateDiff = function (start, end) {
			return moment(end).diff(moment(start), 'minute');
		}

		$scope.clickWork = function (work) {
			$scope.selectedOrderId = work.id;
			$scope.infowindowsOrder.forEach(function (element) {
				element.close();
			}, this);
			$scope.infowindowsOrder[work.id].open($scope.map, $scope.orderMarkers[work.id]);
			$scope.map.panTo(new google.maps.LatLng(Number(work.customer.latitude), Number(work.customer.longitude)));

			google.maps.event.addListener($scope.infowindowsOrder[work.id], 'closeclick', function () {
				$scope.selectedOrderId = 0;
			});
		}

	}
]);